import React, { useState } from "react";
import "./Card.css";
import Modal from "./Modal"; // Importation du composant Modal
import Logo from "../../img/logo.png"; 

const Card = ({ image, heading, detail, color }) => {
  const [showModal, setShowModal] = useState(false); 

  // Fonction pour ouvrir la modal
  const openModal = () => {
    setShowModal(true);
    document.body.classList.add("modal-open"); // Ajoute la classe pour masquer le contenu de la page principale
  };

  // Fonction pour fermer la modal
  const closeModal = () => {
    setShowModal(false);
    document.body.classList.remove("modal-open"); // Supprime la classe pour afficher à nouveau le contenu de la page principale
  };

  return (
    <div className="card" style={{ borderColor: color }}>
      <img style={{ width: "7rem", height: "7rem" }} src={image} alt="" />
      <span>{heading}</span>

      <button className="c-button" onClick={openModal}>LEARN MORE</button>
      {/* Affichage de la modal si showModal est true */}
      {showModal && <Modal closeModal={closeModal} heading={heading} detail={detail} image={image} />}
    </div>
  );
};

export default Card;
